import { Col, Row, Space } from 'antd';
import { get } from 'lodash';
import React, { useCallback, useEffect } from 'react';

import { handleApiErrors } from '../../../api/axiosInstance';
import { COMPANY_API } from '../../../api/company';
import HorizontalSwitch from '../../../components/Switch/HorizontalSwitch';
import CompanyUsersFavrValuesSysAdminTable from '../../../components/Table/CompanyUsersFavrValuesSysAdminTable';
import usePaginatedFiltersQuery from '../../../hooks/queries/usePaginatedFiltersQuery';
import useLocationSearchQueryParser from '../../../hooks/useLocationSearchQueryParser';
import useTableSort from '../../../hooks/useTableSort';
import { replaceCurrentPageSearchQueryParams } from '../../../utils/queryParams';

const FavrRateRefreshStatusReportSection = props => {
  const { t, currentCompany, history, location } = props;

  const searchQueryParams = useLocationSearchQueryParser(location);

  const { stringTableSort, handleTableSort } = useTableSort({ firstName: 1, lastName: 1 });
  const {
    query: favrValuesQuery,
    paginationConfig,
    handlePageChange,
    handlePageSizeChange,
  } = usePaginatedFiltersQuery({
    queryKey: [
      'fetchCompanyFAVRvalues',
      currentCompany._id,
      searchQueryParams.onlyActive,
      searchQueryParams.rateRefreshSuccess,
      stringTableSort,
    ],
    queryFn: () =>
      COMPANY_API.fetchCompanyFAVRvalues(
        currentCompany._id,
        {
          status: searchQueryParams.onlyActive ? ['active'] : [],
          rateRefreshSuccess: searchQueryParams.rateRefreshSuccess,
        },
        paginationConfig.current,
        paginationConfig.pageSize,
        stringTableSort,
      ),
    onError: error => handleApiErrors(error.response),
  });

  const handleFiltersChange = useCallback(
    filters => {
      replaceCurrentPageSearchQueryParams(history, filters);

      if (searchQueryParams.type !== filters.type) {
        if (filters.type === 'future') {
          handleTableSort('nextRunAt', 'ascend');
        } else {
          handleTableSort('lastRunAt', 'descend');
        }
      }
    },
    [history, searchQueryParams.type, handleTableSort],
  );

  useEffect(() => {
    return () => {
      handleFiltersChange({});
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Space direction="vertical">
      <Row justify="end">
        <Col>
          <HorizontalSwitch
            size="medium"
            disabled={favrValuesQuery.isLoading}
            loading={favrValuesQuery.isLoading}
            defaultChecked={!!searchQueryParams.onlyActive}
            onChange={checked => handleFiltersChange({ onlyActive: checked })}
            label={t('showActiveOnly')}
            labelSize="sm"
          />
        </Col>
      </Row>

      <CompanyUsersFavrValuesSysAdminTable
        t={t}
        loading={favrValuesQuery.isFetching}
        dataSource={get(favrValuesQuery.data, 'documents')}
        pagination={{
          pageSize: paginationConfig.pageSize,
          total: paginationConfig.total,
          current: paginationConfig.current,
          onShowSizeChange: handlePageSizeChange,
        }}
        onChange={({ current }, filters, sorters) => {
          handlePageChange(current);
          handleTableSort(sorters?.columnKey, sorters?.order);
        }}
      />
    </Space>
  );
};

export default FavrRateRefreshStatusReportSection;
